import { CartProducts } from '../types'

/** -- toma los idProducts y cantidad guardados en redis, y lo valoriza --*/
export const GET_CART_CACHE = 'GET_CART_CACHE'
export const GET_CART_CACHE_RESET = 'GET_CART_CACHE_RESET'
export const GET_CART_CACHE_ERROR = 'GET_CART_CACHE_ERROR'
export const GET_CART_CACHE_SUCCESS = 'GET_CART_CACHE_SUCCESS'
export interface GetCartCache {
  type: typeof GET_CART_CACHE
  payload: []
}

export interface GetCartCacheError {
  type: typeof GET_CART_CACHE_ERROR
  payload: boolean
}

export interface GetCartCacheSuccess {
  type: typeof GET_CART_CACHE_SUCCESS
  payload: CartProducts | null
}
export interface GetCartCacheReset {
  type: typeof GET_CART_CACHE_RESET
  payload: []
}
